import React from "react";
import { Box, Typography } from "@material-ui/core";
import { Helmet } from "react-helmet";
import { useParams } from "react-router-dom";
import { AccountHeaderTitle } from "../../components/AccountHeader";
import { useFallbackUrl } from "../../components/AppHistory";
import { Crumb } from "../../components/Breadcrumb";
import { PageComponent } from "../routes";
import { TicketsView } from "../../features/Tickets/TicketsView";
import { SuccessNotification } from "../../features/Search/components/SuccessNotification";

export const TicketsPage: PageComponent<{}> = ({ fallbackUrl }) => {
  useFallbackUrl(fallbackUrl);
  const { accountNumber } = useParams();

  return (
    <>
      <Helmet>
        <title>{`${accountNumber} - Account Tickets`}</title>
      </Helmet>

      <AccountHeaderTitle>
        <Typography variant="h4" color="textPrimary">
          Tickets
        </Typography>
      </AccountHeaderTitle>

      {/* Breadcrumb */}
      <Crumb label="Tickets" />

      <Box px={3} py={3}>
        <SuccessNotification />
        <TicketsView />
      </Box>
    </>
  );
};
